import React, { memo, useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';

import TabComp from './tabComp';
import { ExpandButton } from '@components';
import action from '@flux/action';
import FullScreenMarketCap from './fullScreenMarketCap';
import { marketcapViarietyModel, marketcapTimeRangeBtns } from '@model';

// import '@style/modules/analysis/analysisRight.scss';
// import '@style/modules/analysis/expandButton.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/expandButton.scss';
import {
  getValueFromSearchParam,
  removeValueFromSearchParam,
  setURLSearchParam,
} from '@utils/history';
import { useHistory } from 'react-router-dom';
import searchParamKeys from '@model/searchParamKeys';

function MarketCap(props) {
  const { tab: defaultValue, expand: initialExpand } = getValueFromSearchParam(
    searchParamKeys.tab,
    searchParamKeys.expand,
  );
  const [expand, setExpand] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRange, setRange] = useState(2);

  const history = useHistory();
  const onTabChange = useCallback((e, tab) => {
    if (tab) {
      setURLSearchParam(history, { tab });
    }
  }, []);
  const expandCharts = () => {
    setExpand(!expand);
    if (!expand) {
      setURLSearchParam(history, {
        [searchParamKeys.expand]: true,
      });
    } else {
      removeValueFromSearchParam(history, [searchParamKeys.expand]);
    }
  };
  const { chartData, currentId } = props;
  const {
    buyer: { companyName: buyerName = 'BUYER' } = {},
    target: { companyName: targetName = 'TARGET' } = {},
  } = chartData;

  const { fetchData } = props;

  useEffect(() => {
    const { buyer = {}, target = {} } = chartData;

    const hasBuyerData = Object.keys(buyer).length > 0;
    const hasTargetData = Object.keys(target).length > 0;

    if (!hasBuyerData && !hasTargetData && !isLoading) {
      (async () => {
        setIsLoading(true);
        await fetchData(currentId);
        setIsLoading(false);
      })();
    }
    if (initialExpand && !isLoading && (hasBuyerData || hasTargetData)) {
      setExpand(initialExpand);
    }
  }, [currentId, fetchData, chartData, isLoading]);

  const childrenProps = {
    data: chartData,
    isLoading,
    buyerName,
    targetName,
    selectedRange,
    timeRangeBtns: marketcapTimeRangeBtns,
    changeRange: setRange,
    varietyModel: marketcapViarietyModel,
  };
  const tabsProps = {
    onChange: onTabChange,
    defaultValue,
  };

  return (
    <div className={`analysis-right-wrapper ${expand && 'full-screen'}`}>
      <div
        className={`title expand-box ${
          expand ? 'full-screen-title' : 'title-no-bottom-border'
        }`}
      >
        <div>Market Cap</div>
        {!isLoading && (
          <ExpandButton
            onClick={expandCharts}
            scrollPageFooter
            initialExpand={initialExpand}
          />
        )}
      </div>
      {expand ? (
        <FullScreenMarketCap {...childrenProps} />
      ) : (
        <TabComp {...childrenProps} {...tabsProps} />
      )}
    </div>
  );
}

const mapStateToProps = ({ common, analysis }) => {
  const currentId = common.currentId;
  return {
    chartData: (analysis.marketcapData || {})[currentId] || {},
    currentId,
  };
};

const mapDispatchToData = (dispatch) => ({
  async fetchData(id) {
    await dispatch(action.fetchMarketCapData(id));
  },
});

export default connect(mapStateToProps, mapDispatchToData)(memo(MarketCap));
